import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./AboutOurPeople.css";

export const AboutOurPeople = ({
  managementBoard,
  extendedTeam,
  productTeam,
  operationsTeam,
  HRCompliances,
  openModal,
  getMediaUrl,
}) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 1200, min: 992 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 992, min: 576 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
    },
  };
  const responsiveTeam = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 6,
    },
    desktop: {
      breakpoint: { max: 1200, min: 992 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 992, min: 576 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 2,
    },
  };

  const renderTeamMembers = (teamMembers) => {
    if (
      !teamMembers ||
      !teamMembers.teams ||
      teamMembers?.teams?.length === 0
    ) {
      return [];
    }

    return teamMembers.teams.map((person, i) => (
      <div
        className="team-member-card"
        key={i}
        onClick={() => openModal(person)}
      >
        <img
          src={person.imageUrl ? getMediaUrl(person.imageUrl) : person.imageUrl}
          alt={person.name}
          className="team-member-image"
          loading="lazy"
          crossOrigin="anonymous"
        />

        <div className="team-member-info">
          <h5 className="member-name fs-3 fs-md-4">{person.name}</h5>
          <p className="member-title fs-5 ">{person.title}</p>
        </div>
        <div className="discover-link org text-start">Discover →</div>
      </div>
    ));
  };

  const renderTeamMembers2 = (teamMembers) => {
    if (
      !teamMembers ||
      !teamMembers?.teams ||
      teamMembers?.teams?.length === 0
    ) {
      return [];
    }

    return teamMembers?.teams?.map((person, i) => (
      <div
        className="team-member-card"
        key={i}
        onClick={() => openModal(person)}
      >
        <img
          src={person.imageUrl ? getMediaUrl(person.imageUrl) : person.imageUrl}
          alt={person.name}
          className="extended-team-image"
          loading="lazy"
          crossOrigin="anonymous"
        />
        <div className="team-member-info">
          <h5 className="member-name">{person.name}</h5>
          <p className="member-title">{person.title}</p>
        </div>
        <div className="discover-link org text-start">Discover →</div>
      </div>
    ));
  };

  // Helper function to check if team has members
  const hasTeamMembers = (team) => {
    return team && team.teams && team.teams.length > 0;
  };

  // Helper function to render team section conditionally
  const renderTeamSection = (team, title, description, isLargeTeam = false) => {
    if (!hasTeamMembers(team)) {
      return null;
    }

    return (
      <div className="team-section">
        <div className="col-11 m-auto d-md-flex">
          <div className="col-md-3 text-start">
            <p className="fs-5" data-aos="fade-up">
              {team?.titleSmall || "Our People"}
            </p>
            <p className="fs-1 fw-semibold" data-aos="fade-up">
              {team?.titleLarge?.text || title}{" "}
              <span className="org">
                {team?.titleLarge?.highlight || "Team"}
              </span>
            </p>
          </div>
          <div
            className="col-12 col-md-8  d-flex align-items-center"
            data-aos="fade-up"
          >
            <p className="d-flex gap-3 fs-5 fs-md-4 text-start">
              {team?.description || description}
            </p>
          </div>
        </div>
        <Carousel
          responsive={isLargeTeam ? responsiveTeam : responsive}
          infinite={false}
          autoPlay={false}
          arrows={true}
          showDots={false}
          containerClass="carousel-container"
          itemClass="carousel-item-padding-40-px"
        >
          {isLargeTeam ? renderTeamMembers2(team) : renderTeamMembers(team)}
        </Carousel>
      </div>
    );
  };

  return (
    <div className="about-our-people-container">
      {/* Management Board */}
      {hasTeamMembers(managementBoard) && (
        <div className="team-section">
          <Carousel
            responsive={responsive}
            infinite={false}
            autoPlay={false}
            arrows={true}
            showDots={false}
            containerClass="carousel-container"
            itemClass="carousel-item-padding-40-px"
          >
            {renderTeamMembers(managementBoard)}
          </Carousel>
        </div>
      )}

      {/* Extended Team */}
      {renderTeamSection(
        extendedTeam,
        "Extended",
        "The Extended Team brings deep industry experience and specialized expertise to strengthen strategic decision-making and execution.",
        true
      )}

      {/* Product Team */}
      {renderTeamSection(
        productTeam,
        "Product",
        "The Product Team brings deep industry experience and specialized expertise to strengthen strategic decision-making and execution.",
        true
      )}

      {/* Operations Team */}
      {renderTeamSection(
        operationsTeam,
        "Operations",
        "The Operations Team brings deep industry experience and specialized expertise to strengthen strategic decision-making and execution.",
        true
      )}

      {/* HR & Compliances */}
      {renderTeamSection(
        HRCompliances,
        "HR+",
        "The HR & Compliances Team brings deep industry experience and specialized expertise to strengthen strategic decision-making and execution.",
        true
      )}
    </div>
  );
};
